import { render, staticRenderFns } from "./UserFormMini.vue?vue&type=template&id=1f7dfb2c&lang=pug&"
import script from "./UserFormMini.vue?vue&type=script&lang=js&"
export * from "./UserFormMini.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports